import type { IUser } from "../../../../types/models/user.models.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  users: (IUser & { visibleToBrandEnabled: boolean | null | undefined })[];
}

export function useGetEphemeralUsersAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/campaigns/:campaignId/ephemeral-user",
  });
}
